import { Button, CloseButton, InlineNotification } from '@lego/klik-ui';
import { useState } from 'react';
import { Markdown } from '@/components/common/Markdown';
import type { Announcement } from './Announcements';

type Props = {
  announcement: Announcement;
  onDismiss: (id: number) => void;
};

export const AnnouncementItem = ({ announcement, onDismiss }: Props) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <InlineNotification role="status" variant={announcement.variant}>
      <InlineNotification.Content>
        <InlineNotification.Title>{announcement.header}</InlineNotification.Title>
        <InlineNotification.Description>{announcement.summary}</InlineNotification.Description>

        {isExpanded && announcement.moreDetails && <Markdown>{announcement.moreDetails}</Markdown>}
        {announcement.moreDetails && (
          <InlineNotification.Description>
            <Button
              backgroundColor="transparent"
              onClick={() => setIsExpanded(!isExpanded)}
              padding="0"
              size="xs"
              variant="ghost"
            >
              {isExpanded ? 'Show less' : 'More info'}
            </Button>
          </InlineNotification.Description>
        )}
      </InlineNotification.Content>
      <CloseButton aria-label="Close" onClick={() => onDismiss(announcement.id)} />
    </InlineNotification>
  );
};
